import React from "react";
import BreadCrumb from "common/breadcrumb";
import BasicForm from "./basic-form";
import InputSizing from "./input-sizing";
import RangeColor from "./range-color";
import FileGroup from "./file-group";

const FormsBasic= () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Basic Elements" pageTitle="Forms" />

                <BasicForm />
                <InputSizing />
                <RangeColor />
                <FileGroup />
            </div>
        </React.Fragment>
    );
}

export default FormsBasic;